import 'bootstrap/dist/js/bootstrap.bundle.min';
// import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./componentes/nabvar";
import Home from "./componentes/inicio";
import Blogs from "./componentes/blog";
import Contacto from "./componentes/conttacto";
import NoPage from "./componentes/w5";
import Curso from "./componentes/curso"
import Theme from "./componentes/tema"
// import Editor from "./componentes/carreras"
import Wwnw from "./componentes/carreras copy"
import New from "./componentes/carreras copy 3"
import Wwwww from "./componentes/wwcalculadora";
import Chat from "./componentes/message";
import Nosotros from "./componentes/nosotros";
import Documentos from "./componentes/documentos";
import Algoritmos from "./componentes/algoritmos";
import Img from "./componentes/dashboardwww copy";
import Imgw from "./componentes/dashboardwww copy 2";
import Articulos from "./componentes/articulos";

///////////////////////////////////////////////////////////
import Login from './screens/Login.jsx';
import Register from './screens/Register.jsx';
// import Activate from './screens/Activate.jsx';
import Private from './screens/Private.jsx';
import Admin from './screens/Admin.jsx';
import GetPassword from './screens/GetPassword.jsx';
import ResetPassword from './screens/ResetPassword.jsx';
// import PrivateRoute from './Routes/PrivateRoute';
// import AdminRoute from './Routes/AdminRoute';
// import 'react-toastify/dist/ReactToastify.css';
import List from './components/Category.jsx';
// import Timecircle from './components/Timecircle';
// import Curses from './components/Curses';
import Chapters from './components/Chapters';
// import Sections from './components/Seccions';
import Acerca from './components/Forum copy.js';
// import StudentAll from './components/StudentAll';
import React, { Suspense } from "react";
// import Forum from './components/Forum';
// import Theme from './components/Theme.js';
// import Tests from './components/Tests';
// import Testswww from './components/Testswwwww';
// import Alpha from './components/Testswww';
// import './App.css';
import Video from './components/Video';
// import Home from './components/Meet';
// const Curses = React.lazy(() => import("./components/Curses"));

///////////////////////////////////////////////////////////

// import Reports from "./componentes/reporttes";
const Reports = React.lazy(() => import("./componentes/reporttes"));
const Editor = React.lazy(() => import("./componentes/carreras"));

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* <Route path="/" element={<Layout />}> */}
        <Route>
          <Route index element={<Home />} />
          {/* <Route path="/curso/:id" element={<Curso />} /> */}
          <Route path="tema" element={<Theme />} />
          <Route path="login" element={<Login />} />
          <Route path="carpeta" element={<List />} />
          <Route path="blog" element={<Blogs />} />
          <Route path="acerca" element={<Acerca />} />
          <Route path="new" element={<New />} />
          <Route path="/video/:url" element={<Video />}  />
          <Route path="documento" element={<Documentos />} />
          <Route path="img" element={<Img />} />
          <Route path="imgw" element={<Imgw />} />
          <Route path="linea" element={<Suspense fallback={<div>Loading...</div>}> <Editor /> </Suspense>} />
          <Route path="blogesfa" element={<Suspense fallback={<div>Loading...</div>}> <Reports /> </Suspense>} />
          <Route path="articulos" element={<Articulos />} />
          <Route path="/curso/:id" element={<Curso />} />
          <Route path="portafolio" element={<Algoritmos />} />
          <Route path="www" element={<Chat />} />
          {/* <Route path="linea" element={<Editor />} /> */}
          <Route path="new/:idnew" element={<Wwnw />} />
          <Route path="wwwvideo" element={<Wwwww />} />
          <Route path="nosotros" element={<Nosotros />} />
          {/* <Route path="wwwwww" element={<WwwwwW />} /> */}
          <Route path="contacto" element={<Contacto />} />
          <Route path="*" element={<NoPage />} />
          <Route path="/login" exact component={Login} />

          <Route path="/register" element={<Register />} />
          <Route path="/users/password/forget" element={<GetPassword />} />
          <Route path="/users/password/reset/:token" element={<ResetPassword />} />
          {/* <Route path="/users/activate/:token" element={<Activate />} /> */}
          <Route path="/private" exact component={Private} />
          <Route path="/admin" exact component={Admin} />
          {/* <PrivateRoute path="/private" exact component={Private} />
          <AdminRoute path="/admin" exact component={Admin} /> */}


        </Route>
      </Routes>
    </BrowserRouter>);
}

export default App;
//https://askubuntu.com/questions/1403619/mongodb-install-fails-on-ubuntu-22-04-depends-on-libssl1-1-but-it-is-not-insta